import { useContext } from 'react';

import { RealtimeContext, RealtimeContextValue } from './realtime-context';

export function useRealtime(): RealtimeContextValue {
  const ctx = useContext(RealtimeContext);
  if (!ctx) throw new Error('useRealtime must be used within RealtimeProvider');
  return ctx;
}
